import React, {useState, useEffect} from 'react';
import {change, Field} from "redux-form";
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from "react-redux";
import {isArray, isEmpty, isObject, keys} from 'underscore';
import dotProp from "dot-prop-immutable";

import * as ComplexPropTypes from '../../complexPropTypes';
import {optionId} from "../../../../utils/utils";

const Checkboxes = ({itemCols, extraUlStyles, value, name, options }) => {
    const [lastClick, setLastClick] = useState(null);
    const _value = useSelector(state => state.form.wizard.values[name]);
    const _selectedOptions = isObject(_value) ? keys(_value).filter(key => _value[key]) : [];
    const dispatch = useDispatch();
    const naOptionExists = options.includes('N/A');
    const naOptionId = `check_${name}_N/A`;

    useEffect(() => {
        if (isArray(_value)) {
            if (isEmpty(_value)) {
                // If this bugs will happen again - possible next step is adding custom ReduxComponent and patching value in run-time
                console.error('ACA-464 - admission values must be patched OR checkboxes will be unselectable - trying to patch it', name, _value)
                updateCheckboxesValue(null);
            } else {
                // Convert array format ["Anxiety", "Depression"] to object format {"Anxiety": true, "Depression": true}
                const objectValue = _value.reduce((acc, item) => ({...acc, [item]: true}), {});
                updateCheckboxesValue(objectValue);
            }
        }
    }, []);
    useEffect(() => {
        if (lastClick && (_selectedOptions.length > 1) && dotProp.get(_value, 'N/A')) {
            if (lastClick === naOptionId) {
                updateCheckboxesValue({'N/A':true});
            } else {
                updateCheckboxesValue({..._value, 'N/A':false});
            }
        }
    }, [_value]);

    const updateCheckboxesValue = (value) => dispatch(change('wizard', name, value));
    const handleCheckboxesChange = (event) => setLastClick(event.target.id);

    return (
        <div className={itemCols}>
            <ul className={`check-list list-unstyled d-flex flex-wrap flex-row ${extraUlStyles || ''}`}>
                {options.map((option, index) => (
                    <li key={index}>
                        <div className="custom-control custom-checkbox">
                            <Field component="input"
                                   type="checkbox"
                                   className="custom-control-input"
                                   onChange={handleCheckboxesChange}
                                   id={`check_${name}_${option.value.replace(' ', '_')}`}
                                   name={`${name}[${option.value}]`}/>
                            <label className="custom-control-label p-0 m-0"
                                   htmlFor={`check_${name}_${option.value.replace(' ', '_')}`}>
                                {option.label}
                            </label>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

Checkboxes.propTypes = {
    itemCols: PropTypes.string.isRequired,
    extraUlStyles: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: ComplexPropTypes.optionsArray.isRequired
};

export default Checkboxes;